export default __webpack_public_path__ + "static/media/Proxima Nova Black.120f91ca.otf";